import { render, staticRenderFns } from "./PostaForma.vue?vue&type=template&id=6ae705f9&scoped=true&"
import script from "./PostaForma.vue?vue&type=script&lang=js&"
export * from "./PostaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae705f9",
  null
  
)

export default component.exports